export enum AttachmentCategory {
    INVOICE = 'invoice',
    CONSENT = 'consent'
}
